module.exports = __webpack_public_path__ + "static/media/b2_p9_crystal.efa49782.mp3";